import React, { useEffect, useState } from "react";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CustomPopupForm from "../../../component/customPopupModel";
import { useSnackbar } from "../../../component/SnackbarContext";
import axiosInstance from "../../../configuration/request";
import { MdCampaign } from "react-icons/md";
import { timeAgo } from "../../../utils/timeAgo";

function Broadcast() {
    const [open, setOpen] = useState(false);
    const [broadcasts, setBroadcasts] = useState([]); // store data
    const showSnackbar = useSnackbar();

    useEffect(() => {
        fetchBroadcast();
    }, []);

    const fetchBroadcast = () => {
        axiosInstance
            .get(`/customer/delivery-person/broadcast`)
            .then((res) => {
                setBroadcasts(res?.data || []); // save response
            })
            .catch((error) => {
                showSnackbar(
                    error?.response?.data?.message || "Something went wrong!",
                    "error"
                );
            });
    };

    const handleCreateUser = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div className="h-[calc(100vh-90px)] overflow-y-auto w-full px-4 sm:px-6 pb-6 md:px-8" >
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold">Broadcast</h2>
                <CustomButton
                    onClick={handleCreateUser}
                    customeClass="gradient-button w-[170px] h-[45px] mr-1"
                >
                    <span className="text-xl mr-[4px]">+</span>Create Broadcast
                </CustomButton>
            </div>

            {/* List */}
            <div className="grid grid-cols-1  lgs:grid-cols-2 gap-6">
                {broadcasts.length > 0 ? (
                    broadcasts.map((item) => {
                        const createdAt = new Date(item.createdAt);
                        const formattedDate = createdAt.toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                        });
                        const formattedTime = createdAt.toLocaleTimeString(undefined, {
                            hour: "2-digit",
                            minute: "2-digit",
                        });

                        return (
                            <div
                                key={item.id}
                                className="group flex items-start gap-4 p-5 bg-white border border-gray-200 rounded-xl shadow-lg transition-all duration-300 ease-in-out "
                            >
                                {/* Left Icon */}
                                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#1B7EB8] flex items-center justify-center text-white shadow-md  transition-colors duration-300">
                                    <MdCampaign className="text-2xl" />
                                </div>

                                {/* Content */}
                                <div className="flex flex-col justify-between">
                                    <div className="flex justify-between items-start flex-wrap gap-2">
                                        <div>
                                            <div className="flex justify-between items-center flex-wrap">
                                                <h3 className="font-semibold text-base md:text-lg text-[#063853] group-hover:text-[#1B7EB8] transition-colors duration-300">
                                                    {item.title}
                                                </h3>
                                                <div className="text-xs md:text-sm text-gray-400 text-right">
                                                    {formattedDate} • {formattedTime}
                                                </div>
                                            </div>

                                            <p className="mt-1 text-sm md:text-sm lg:text-base text-gray-600 leading-relaxed group-hover:text-gray-800 transition-colors duration-300">
                                                {item.message}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex w-full justify-end items-end text-xs md:text-sm text-gray-400 text-right">
                                        <div>{timeAgo(item.createdAt)}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center text-gray-500 py-8 italic">
                        No broadcasts available.
                    </div>
                )}
            </div>

            {/* Popup Form */}
            <CustomPopupForm
                isOpen={open}
                handleClose={handleClose}
                dialogType="broadcast"
                onSubmit={() => {
                    setOpen(false)
                    fetchBroadcast()
                }}
            />
        </div>
    );
}

export default Broadcast;
